module.exports = __webpack_public_path__ + "img/details_01.d8c25b2c.png";